<template>
  <div class="py-3 min-w-0 w-full">
    <div class="display-1">Välittäjät</div>

    <v-card class="mt-2">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isAuthorized('realtor', 'create')"
          color="info"
          class="mb-2"
          @click="
            edit = false;
            realtorDialog = true;
          "
          >Uusi välittäjä</v-btn
        >
      </v-card-title>

      <v-container>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Hae kaikista kentistä..."
              single-line
              hide-details
              solo
              @keyup.enter="getDataFromApi()"
              @click:append="getDataFromApi()"
            ></v-text-field>
          </v-col>
          <v-col> </v-col>
        </v-row>
      </v-container>

      <v-data-table
        :headers="headers"
        :items="realtors"
        :footer-props="globalValues.footerProps"
        :items-per-page="getDefaultTableRows()"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalLength"
      >
        <!-- Client id and name -->
        <template #[`item.name`]="{ item }">
          <strong> {{ item.name }} </strong>
          <br />
          <span>Asiakasnum # {{ item.clientId }} </span>
        </template>

        <!-- Actions -->
        <template #[`item.actions`]="{ item }">
          <div class="action-grid-container">
            <v-icon
              v-if="isAuthorized('realtor', 'edit')"
              title="Muokkaa"
              small
              @click="
                edit = true;
                setCurrentRealtor(item);
                realtorDialog = true;
              "
              >mdi-pencil</v-icon
            >
            <v-icon
              v-if="isAuthorized('realtor', 'delete')"
              title="Poista"
              small
              @click="deleteItem(item)"
              >mdi-delete</v-icon
            >
          </div>
        </template>
        <template #no-data>
          <h2>Ei välittäjiä</h2>
        </template>
      </v-data-table>
    </v-card>

    <!-- RealtorForm dialog -->
    <realtor-form v-model="realtorDialog" :edit="edit"></realtor-form>
  </div>
</template>

<script>
import RealtorForm from "../../components/Realtor/RealtorForm.vue";
import mixins from "../../mixins/mixins";
import { mapActions, mapState, mapMutations } from "vuex";
import globalValues from "@/configs/globalValues";

export default {
  title: "Välittäjät",

  mixins: [mixins],

  components: {
    RealtorForm,
  },

  data() {
    return {
      realtorDialog: false,
      edit: false,
      loading: true,
      options: {},
      dialog: false,
      search: "",
      headers: [
        {
          text: "Välittäjä",
          value: "name",
          sortable: false,
        },
        {
          text: "Puhelin",
          value: "phone",
          sortable: false,
        },
        {
          text: "Email",
          value: "email",
          sortable: false,
        },
        {
          text: "Toiminnot",
          value: "actions",
          sortable: false,
        },
      ],
      globalValues,
    };
  },

  computed: {
    ...mapState("realtor", ["realtors", "totalLength"]),
    ...mapState("browsehistory", [
      "dataTablePage",
      "getPreviousPage",
      "itemsPerPage",
      "mainSearchValue",
    ]),
  },

  watch: {
    options: {
      handler() {
        if (this.getPreviousPage) {
          if (this.mainSearchValue != "") this.search = this.mainSearchValue;
          this.options.page = this.dataTablePage;
          this.options.itemsPerPage = this.itemsPerPage;
        }
        this.saveTableOptions({ ...this.options });
        this.getDataFromApi();
      },
      deep: true,
    },

    totalLength() {
      this.options.page = 1;
    },
  },

  methods: {
    ...mapActions("realtor", ["getRealtors", "inActivateRealtor"]),
    ...mapMutations("realtor", ["setCurrentRealtor"]),
    ...mapMutations("browsehistory", ["saveTableOptions", "saveMainSearchTerm"]),

    async getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      // Save main search term
      this.saveMainSearchTerm(this.search);

      let search = this.search.trim().toLowerCase();
      let url = `/api/v1/realtor/getAll?sortBy=${sortBy}&sortDesc=${sortDesc}&page=${page}&itemsPerPage=${itemsPerPage}&search=${search}`;

      await this.getRealtors(url);

      this.loading = false;
    },

    deleteItem(item) {
      if (confirm("Haluatko varmasti poistaa välittäjän: " + item.name))
        this.inActivateRealtor(item._id);
    },
  },
};
</script>

<style scoped></style>
